import { render, staticRenderFns } from "./Pagination-400.vue?vue&type=template&id=15742c8b"
import script from "./Pagination-400.vue?vue&type=script&lang=js"
export * from "./Pagination-400.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports